import { createGlobalStyle, css } from 'styled-components';

export default createGlobalStyle`
  * {
    box-sizing: border-box;
    scrollbar-width: thin;
    scrollbar-color: #90A4AE #CFD8DC;
    :focus {
      outline: none;
    }
  }

  html {
    font-size: 18px;
  }

  body {
    --bg-primary: 255, 255, 255;
    --bg-secondary: 225, 225, 225;
    --bg-tertiary: 210, 210, 210;
    --text-primary: 24, 24, 24;
    --text-secondary: 52, 73, 94;
    --text-tertiary: 253, 94, 83;
    --bg-alpha: 0.33;

    /* bg colors */
    --bg: #3498db;
    --c1: #ecf0f1;
    --c2: #d35400;
    --c3: #2c3e50;
    --c4: #f1c40f;
    --c5: #27ae60;

    --sidebar-width: 250px;
    --icon-button-size: 3rem;

    --content-width: 1080px;

    --spacer: 1rem;
    --spacer-small: 0.5rem;

    --border-radius: 0.5rem;

    --card-size: 100%;

    background-color: rgb(var(--bg-primary));
    color: rgb(var(--text-primary));

    font-family: 'Rubik', sans-serif;
    line-height: 1.33;

    background-color: #deb5ee;

    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;

    @media (min-width: 660px) {
      --card-size: 320px;
    }

    @media (max-width: 900px) {
      --content-width: 100vw;
    }

    padding: 0;
    margin: 0;
  }

  @supports (-webkit-backdrop-filter: none) or (backdrop-filter: none) {
    body {
      --glass-bg: rgba(var(--bg-primary), 0.2);
      --glass-border: 0.066rem solid rgba(var(--bg-primary), 0.33);
      --glass-glow: 0 0.5rem 2rem 0 rgba(var(--bg-secondary), 0.33);
      --glass-filter: blur(0.4rem);

      --glass-bg-hover: rgba(var(--bg-primary), 0.75);
      --glass-glow-hover: 0 0.5rem 2rem 0 rgba(var(--bg-secondary), 0.66);
    }
  }

  @supports not ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    body {
      --glass-bg: rgba(var(--bg), 0.8);
      --glass-border: 0.066rem solid rgba(var(--bg-primary), 0.33);
      --glass-glow: 0 0.5rem 2rem 0 rgba(var(--bg-secondary), 0.33);

      --glass-bg-hover: rgba(var(--bg-primary), 0.90);
      --glass-glow-hover: 0 0.5rem 2rem 0 rgba(var(--bg-secondary), 0.66);
    }
  }


  @media (prefers-color-scheme: dark) {
    body {
      -webkit-font-smoothing: antialiased;

      --bg-primary: 33, 36, 43;
      --bg-secondary: 40, 44, 53;
      --bg-tertiary: 25, 28, 34;
      --text-primary: 255, 255, 255;
      --text-secondary: 181, 184, 191;
      --text-tertiary: 255, 99, 99;

      --box-shadow-color: rgba(255,255,255);

      /* bg colors */
      --bg: #34495e;
      --c1: #ecf0f1;
      --c2: #d35400;
      --c3: #2c3e50;
      --c4: #f1c40f;
      --c5: #3498db;

      background-color: #34283b;
    }
  }

  h1, h2, h3, h4, h5, a , p {
    margin: 0;
  }

  h1 {
    font-size: 2rem;
    font-weight: 700;
  }

  h2 {
    font-size: 1.75rem;
    font-weight: 700;
  }

  h3 {
    font-size: 1.5rem;
    font-weight: 700;
  }

  h4 {
    font-size: 1.25rem;
    font-weight: medium;
  }

  h5 {
    font-size: 1rem;
    font-weight: medium;
  }

  p {
    font-weight: 400;
    font-size: 1rem;
  }

  a {
    color: rgb(var(--text-tertiary));
    text-decoration: none;

    h1, h2, h3, h4, h5 {
      text-decoration: none;
      color: inherit;
    }
  }

  p {
    margin: 0 0 1rem 0;
  }

  hr {
    border: none;
    height: 2px;
    width: 100%;
    background-color: rgb(var(--text-tertiary));
  }
`;

export const boxShadow = css`
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
`;

export const boxShadowHover = css`
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);

  :hover, :focus, :focus-within {
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.25), 0 8px 8px rgba(0, 0, 0, 0.22);
  }

  transition: box-shadow 250ms ease-in-out;
`;
